module.exports = __webpack_public_path__ + "assets/img/john_paul_dejoria-5c49ca6a.jpg";